import React, { useCallback } from 'react'
import { eventClient } from '@opus/web.core.lib.event-tracking'
import { default as MuiButton } from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'

export const Button = ({ loading, children, disabled, startIcon, ...props }) => {
	const handleClick = useCallback(() => {
		if (props.onTrackingEvent) {
			props.onTrackingEvent()
		} else if (props.eventId) {
			eventClient.logClickEvent(props.eventId, props.eventParams).catch((error) => console.log(`Error tracking data ${props.eventId}`, error.message))
		}
	}, [props])

	return (<MuiButton disabled={loading || disabled} startIcon={loading ? <CircularProgress style={{
		width: '22px', height: '22px',
	}} /> : startIcon} onClick={handleClick} {...props}>
		{children}
	</MuiButton>)
}

Button.defaultProps = {
	fullWidth: true, color: 'primary', variant: 'contained', size: 'large',
}
